import gtm from 'eco-design-reliance/gtm';
import { ItfGTM31Entire, ItfGTM31 } from './type';

// https://ecoflow.feishu.cn/wiki/GXWPwndwGi5lkMk5fn7cG5CNnXI 新版埋点
export const handle_GTM_31 = (data: ItfGTM31) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'sidebar_checkout' } as ItfGTM31Entire);
};
